import React from "react";

//components
import LoadingCenter from "./LoadingCenter";
import SwitchCheckbox from "./Forms/SwitchCheckbox";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";

import { useAuth } from "../providers/auth";
import api from "../services/api";
import openToast from "../utils/sweetAlert";

const BoxCustomerMenu = (props) => {
  const { user } = useAuth();

  const [response, setResponse, loading, error, axiosFetch ] = useAxiosFunction();

  const [status, setStatus] = React.useState(props.user.status);
  const [approved, setApproved] = React.useState(props.user.approved);
  const [defaulter, setDefaulter] = React.useState(props.user.juridic);
  const [important, setImportant] = React.useState(props.user.important);

  const handleStatus = () => {
    const isStatus = status ? 0 : 1;

    axiosFetch({
      axiosInstance,
      method: "POST",
      url: "/users/edit",
      redirect_to: "",
      data: {
        "user_id": props.user.id,
        "body": {
          "status": isStatus
        }
      }
    });

    setStatus(!status);
  }

  const handleApprove = () => {
    const isApproved = approved ? 0 : 1;

    axiosFetch({
      axiosInstance,
      method: "POST",
      url: "/users/edit",
      redirect_to: "",
      data: {
        "user_id": props.user.id,
        "body": {
          "approved": isApproved
        }
      }
    });

    setApproved(!approved);
  }

  const handleDefaulter = () => {
    if (defaulter) {
      axiosFetch({
        axiosInstance,
        method: "POST",
        url: "/users/tirar/juridico/" + props.user.id,
        redirect_to: "",
        data: {}
      });

      setDefaulter(false);
    } else {
      axiosFetch({
        axiosInstance,
        method: "POST",
        url: "/users/setar/juridico/" + props.user.id,
        redirect_to: "",
        data: {}
      });

      setDefaulter(true);
    }
  }

  const handleImportant = async () => {
    try {
      const response = await api.post("/users/important/" + props.user.id, {}, { headers: { "Authorization": "Bearer " + user.token } });

      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
        setImportant(!important);
      }

      if (response.data.error) {
        openToast("error", "Erro", response.data.message);
      }
    } catch (error) {
      if (error.response?.data.error) {
        openToast("error", "Erro", response.data.message);
      }
    }
  }

  return (
    <div className="box">
      {loading && <LoadingCenter />}
      {!loading && <ul className="box__nav">
        <li className="box__item">
          <div className="box__wrapper">
            <span className="box__name">Status</span>
            <div className="box__switch">
              <SwitchCheckbox variant="success" checked={status}
                onChange={handleStatus} initialState={false} disabled={props.disabled} />
            </div>
          </div>
        </li>

        <li className="box__item">
          <div className="box__wrapper">
            <span className="box__name">Aprovado</span>
            <div className="box__switch">
              <SwitchCheckbox variant="success" checked={approved}
                onChange={handleApprove} initialState={false} disabled={props.disabled} />
            </div>
          </div>
        </li>

        <li className="box__item">
          <div className="box__wrapper">
            <span className="box__name">Importante</span>
            <div className="box__switch">
              <SwitchCheckbox variant="warning" checked={important}
                onChange={handleImportant} initialState={false} disabled={props.disabled} />
            </div>
          </div>
        </li>

        <li className="box__item">
          <div className="box__wrapper box__wrapper--border-none">
            <span className="box__name">Inadimplente</span>
            <div className="box__switch">
              <SwitchCheckbox variant="error" checked={defaulter}
                onChange={handleDefaulter} initialState={defaulter} disabled={props.disabled} />
            </div>
          </div>
        </li>
      </ul>}
    </div>
  );
}

BoxCustomerMenu.defaultProps = {
  disabled: false
}

export default BoxCustomerMenu;